export default {
  googleOrigin: 'jcLogin',
  partnerMarketing: 'jcPartnerMarketing',
  segmentMap: 'jcSegmentMap',
  visitorId: 'visitorId',
  segmentUuid: 'segmentUuid',
};
